import React, { Component } from 'react'
import debounce from 'lodash.debounce'
import Button from 'components/UI/Button/Button'
import Icon from 'components/UI/Icon/Icon'
import { Wrapper, StyledSelect, StyledButton, ClassroomIcon } from './StudentInfoRow.styles'
import { StyledFormInput } from '../../../../DashboardSettings.styles'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'
import Axios from 'axios'
import config from 'config'
import FileSaver from 'file-saver'

export default class StudentInfoRow extends Component {
  constructor (props) {
    super(props)

    this.state = {
      screenWidth: 0,
      isDownloadingInfo: false
    }

    this.updateScreenWidth = this.updateScreenWidth.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
    this.debouncedInputChange = debounce(this.onInputChange, 500)
  }

  componentDidMount () {
    this.updateScreenWidth()
    window.addEventListener('resize', this.updateScreenWidth)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.updateScreenWidth)
  }

  updateScreenWidth () {
    const screenWidth = window.innerWidth ||
			document.documentElement.clientWidth ||
			document.body.clientWidth
    this.setState({ screenWidth })
  }

  onInputChange (target) {
    this.props.setStudentState({
      _id: this.props.info._id,
      field: target.name,
      value: target.value
    })
  }

  onDownloadStudentInfo () {
    this.setState({ isDownloadingInfo: true })

    const isParent = this.props.isParent

    const data = {
      template: isParent ? 'child_letter' : 'student_letter',
      data: {
        student: this.props.info
      }
    }

    Axios({
      method: 'post',
      url: `https://europe-west1-awesome-caster-213612.cloudfunctions.net/generate-teacher-pdf`,
      data,
      responseType: 'blob'
    }).then(res => {
      FileSaver.saveAs(new Blob([res.data], { type: 'application/pdf' }), `NZK-Student-Letters.pdf`)

      this.setState({ isDownloadingInfo: false })
    })
  }

  render () {
    const { info, isEditMode, isParent, openParentEmailPopup } = this.props
    const { screenWidth } = this.state

    const commonProps = {
      placeholderColor: isEditMode ? colors.grey : colors.orange,
      backgroundColor: isEditMode ? null : colors.paleBlue,
      inputColor: isEditMode ? null : colors.darkPurple,
      noBorder: !isEditMode,
      focusColor: colors.orange,
      backgroundFocusColor: colors.lightOrange,
      element: 'button',
      disabled: !isEditMode,
      autoComplete: 'off',
      narrow: true,
      textSize: '15px',
      fieldNameSize: '18px',
      inputOpacity: info.stagedForDeletion ? '0.5' : '1',
      width: screenWidth <= 950 ? '120px' : '140px'
    }

    return (
      <Wrapper>
        <StyledFormInput
          {...commonProps}
          value={info.name}
          onChange={(e) => this.debouncedInputChange(e.target)}
          name='name'
          placeholder='First name'
        />
        {/* autofill fix */}
        <input
          value='autofix'
          onChange={() => {}}
          name='username'
          placeholder='Username'
          hidden
        />
        {/* autofill fix */}
        <StyledFormInput
          {...commonProps}
          value={info.username}
          onChange={(e) => this.debouncedInputChange(e.target)}
          name='username'
          placeholder='Username'
          customValidator={{
            test: async (e) => {
              const isValid = await this.props.isValidUsername(e, info._id)
              return isValid
            },
            errorMessage: 'Username taken or invalid',
            preSubmit: true,
            checkOnMount: true,
            isRequired: true
          }}
          required
        />
        <StyledFormInput
          {...commonProps}
          value={info.password}
          onChange={(e) => this.debouncedInputChange(e.target)}
          name='password'
          placeholder='••••••••••'
          placeholderColor={isEditMode ? colors.grey : colors.darkPurple}
          type='password'
          validations='minLength:4'
          validationError='Password too short'
        />
        {/* autofill fix */}
        <input
          value='autofix'
          onChange={() => {}}
          name='email'
          placeholder='Email'
          hidden
        />
        {/* autofill fix */}
        {!isParent &&
        <StyledFormInput
          {...commonProps}
          value={info.parentEmail}
          onChange={(e) => this.debouncedInputChange(e.target)}
          onFocus={openParentEmailPopup}
          name='parentEmail'
          placeholder='Parent email'
          width={screenWidth <= 950 ? '120px' : '220px'}
          validations='isEmail'
          validationError='Email not valid'
        />
        }
        <StyledSelect
          {...commonProps}
          value={info.yearGroup}
          onChange={(e) => this.debouncedInputChange(e.target)}
          name='yearGroup'
          options={[
            { title: 'up to 7', value: 1 },
            { title: '7-8', value: 2 },
            { title: '8-9', value: 3 },
            { title: '9-10', value: 4 },
            { title: '10-11', value: 5 },
            { title: '11 and above', value: 6 }
          ]}
          noArrow={info.stagedForDeletion}
        />
        { !info.stagedForDeletion && (
          isEditMode ? (
            <StyledButton
              element='button'
              type='button'
              size='regular'
              key={1}
              round
              bgColor={isEditMode ? colors.red : this.props.isGoogleGroup ? 'rgba(0,0,0,0)' : colors.lightBlue}
              onClick={() => this.props.onRemoveStudent(info._id)}
            >
              <Icon
                name='trash'
                color='white'
                size='regular'
              />
            </StyledButton>
          ) : (
            <StyledButton
              element='button'
              key={2}
              type='button'
              size='regular'
              round
              bgColor={this.props.isGoogleGroup ? 'rgba(0,0,0,0)' : colors.lightBlue}
              disabled={this.state.isDownloadingInfo}
              onClick={() => this.props.isGoogleGroup ? this.props.syncGoogleStudents() : this.onDownloadStudentInfo()}
            >{this.props.isGoogleGroup
              ? !info.google && !info.demo ? <ClassroomIcon /> : null
              : <Icon name='print' color='white' size='regular' />
            }</StyledButton>
          )
        )}
      </Wrapper>
    )
  }
}
